import { Component, Input, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { CatalogItem } from '../../../models/catalog/catalogItem';
import { FormMode } from '../../../core/constants';
import { TextModes } from '../../ui/controls/text-input/text-input.component';
import { Textbox } from '../../../../../../../libs/Shared/components/inputs/textbox/textbox';
import { serializablePropsAreEqual } from '../../../core/type-helpers';

@Component({
  selector: 'app-catalog-item',
  standalone: false,
  templateUrl: './catalog-item.component.html',
})
export class CatalogItemComponent {
  FormMode = FormMode;
  InputTextModes = TextModes;

  @Input() data: Partial<CatalogItem> = CatalogItem.createEmpty();
  @Input() mode: FormMode = FormMode.View;
  @ViewChildren(Textbox) textInputs!: QueryList<Textbox>;

  itemValid = false;
  itemChanged = false;
  _data: Partial<CatalogItem> = CatalogItem.createEmpty();

  constructor() {}

  checkItemValid(): void {
    this.itemChanged = !serializablePropsAreEqual(this._data, this.data, ['name', 'description', 'price', 'isDiscount'])
    if (!this.textInputs) {
      return; // view not ready yet — nothing to validate against
    }
    
    this.itemValid = this.textInputs.toArray()
      .map(control => control.checkValiditySilently())
      .every(isValid => isValid)
    // console.log({ itemValid: this.itemValid, itemChanged: this.itemChanged, _data: { ...this._data } });
  }

  loadData(): void {
    this._data = this.data !== undefined ? (this.data as CatalogItem).clone() : CatalogItem.createEmpty();
    this.checkItemValid();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.loadData();
    }
  }

  ngAfterViewInit(): void {
    this.loadData();
    this.checkItemValid();
  }

  public get catalogItem(): CatalogItem {
    return new CatalogItem(this._data);
  }
}
